import React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { Loader } from '../../Components/Loader/Loader';
import { getFor } from '../../ReactComponents/API';
import { PaymentProcessingDto } from './PaymentProcessingDto.csharp';
import { PaymentProcessingPageProps } from './PaymentProcessingPageProps.csharp';

export class PaymentProcessingPage extends React.Component<PaymentProcessingPageProps> {
    private STATUS_CHECK_DELAY = 4000;
    private REQUEST_DELAY = 1000;
    private FALLBACK_TIMEOUT_MINUTES = 11;
    private FALLBACK_TIMEOUT_DATE = new Date().setMinutes(new Date().getMinutes() + this.FALLBACK_TIMEOUT_MINUTES);

    componentDidMount() {
        setTimeout(this.tryCheckPaymentStatus, this.STATUS_CHECK_DELAY);
    }

    private tryCheckPaymentStatus = () => {
        let url = `${this.props.checkPaymentStatusUrl}?transactionId=${this.props.transactionId}`;
        if (this.props.authToken) url += `&auth=${this.props.authToken}`;

        getFor<PaymentProcessingDto>(url)
            .then((dto) => {
                if (dto.isSuccess) {
                    window.location.href = dto.redirectUrl;
                    return;
                }

                if (new Date().getTime() <= this.FALLBACK_TIMEOUT_DATE) {
                    setTimeout(this.tryCheckPaymentStatus, this.REQUEST_DELAY);
                } else {
                    this.redirectToFallback();
                }
            })
            .catch(() => {
                this.redirectToFallback();
            });
    };

    private redirectToFallback = () => {
        window.location.href = this.props.fallbackUrl;
    };

    render() {
        return (
            <div className="PaymentProcessing">
                <img src="/dist/assets/images/payment-processing.svg" alt="Betaling utføres" className="PaymentProcessing__Image" />
                <h1 className="PaymentProcessing__Title">{getTranslation(keys['payment.processing'])}</h1>
                <span className="PaymentProcessing__Subtitle">{getTranslation(keys['payment.pleaseWait'])}</span>

                <div className="PaymentProcessing__Loader">
                    <Loader isLoading />
                </div>
            </div>
        );
    }
}
